/* Keep native email links usable even without a configured mail app. */
(() => {
  'use strict';
  if (window.PawEmailContact) return;
  let dialog, opener, address;
  function prepare() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'email-contact'; dialog.id = 'email-contact';
    dialog.setAttribute('aria-labelledby', 'email-contact-title');
    dialog.innerHTML = `<div class="email-contact-head"><h2 id="email-contact-title">Let’s talk.</h2><button type="button" data-email-close aria-label="Close email options">×</button></div><p data-email-purpose></p><label for="email-contact-address">Email address</label><div class="email-contact-address"><input id="email-contact-address" type="text" readonly spellcheck="false"><button type="button" data-email-copy>Copy address</button></div><p class="email-contact-status" role="status" aria-live="polite"></p><div class="email-contact-actions"><a class="button" data-email-direct>Open email app <span aria-hidden="true">↗</span></a><a data-email-gmail target="_blank" rel="noopener noreferrer">Write in Gmail ↗</a><a data-email-form>Use our contact form →</a></div><p class="email-contact-help">If no email app opens, copy the address into your usual email service. You can attach photos there.</p>`;
    document.body.append(dialog); address = dialog.querySelector('input');
    dialog.querySelector('[data-email-form]').addEventListener('click', () => dialog.close());
    dialog.querySelector('[data-email-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => opener?.focus({preventScroll:true}));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
    });
    dialog.querySelector('[data-email-copy]').addEventListener('click', async () => {
      const status = dialog.querySelector('[role=status]');
      try { await navigator.clipboard.writeText(address.value); status.textContent = 'Email address copied.'; }
      catch { address.focus(); address.select(); status.textContent = 'The address is selected. Copy it, then paste it into your email service.'; }
    });
  }
  function open(link) {
    const href = link.getAttribute('href'), parsed = new URL(href);
    let email;
    try { email = decodeURIComponent(parsed.pathname); } catch { return; }
    if (!/^[^\s<>@]+@pawchibi\.com$/i.test(email)) return;
    prepare(); opener = link; address.value = email;
    const order = email.toLowerCase() === 'studio@pawchibi.com';
    dialog.querySelector('[data-email-purpose]').textContent = order ? 'For orders, previews and updates. Include your order number if you have it.' : 'For photo advice, questions before ordering, and anything else.';
    dialog.querySelector('[role=status]').textContent = '';
    dialog.querySelector('[data-email-direct]').href = href;
    const gmail = new URL('https://mail.google.com/mail/');
    gmail.searchParams.set('view','cm'); gmail.searchParams.set('fs','1'); gmail.searchParams.set('to',email);
    if (parsed.searchParams.has('subject')) gmail.searchParams.set('su',parsed.searchParams.get('subject'));
    if (parsed.searchParams.has('body')) gmail.searchParams.set('body',parsed.searchParams.get('body'));
    dialog.querySelector('[data-email-gmail]').href = gmail.href;
    const contact = new URL('/pages/contact', location.href);
    contact.searchParams.set('topic',order?'order':'general'); contact.hash='contact-form';
    const params = new URLSearchParams(location.search);
    if (params.get('quiet') === '1' || document.body.dataset.quiet === 'true') contact.searchParams.set('quiet','1');
    if (params.has('preview_theme_id')) contact.searchParams.set('preview_theme_id',params.get('preview_theme_id'));
    dialog.querySelector('[data-email-form]').href = contact.href;
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('[data-email-direct]').focus({preventScroll:true});
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href^="mailto:"]');
    if (!link || link.hasAttribute('data-email-direct') || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (!/@pawchibi\.com(?:\?|$)/i.test(link.getAttribute('href'))) return;
    event.preventDefault(); open(link);
  });
  window.PawEmailContact = Object.freeze({open});
  // Policy paragraphs containing plain email addresses use the same choices.
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (walker.nextNode()) {
    const node = walker.currentNode;
    if (/(?:hello|studio)@pawchibi\.com/i.test(node.textContent) && !node.parentElement.closest('a,button,script,style,textarea,input,noscript,pre,code,[contenteditable]')) nodes.push(node);
  }
  nodes.forEach(node => {
    const parts = node.textContent.split(/((?:hello|studio)@pawchibi\.com)/gi);
    const fragment = document.createDocumentFragment();
    parts.forEach((part,index) => {
      if (index % 2) {const link=document.createElement('a');link.href='mailto:'+part;link.textContent=part;link.className='email-inline';fragment.append(link);}
      else fragment.append(document.createTextNode(part));
    });
    node.replaceWith(fragment);
  });
})();
